"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialListItemText = exports.MaterialListItemTextUnstyled = void 0;
const material_ui_1 = require("material-ui");
const List_1 = require("material-ui/List");
const react_1 = require("react");
const React = require("react");
require("./list-item-text.less");
const decorate = material_ui_1.withStyles(theme => ({
    root: {
        flex: "1 1 135px",
        fontSize: "13px",
        padding: "unset",
        paddingRight: "10px"
        // whiteSpace: "normal",
        // wordBreak: "break-word"
    },
    header: {
        display: "flex",
        flex: "0 0",
        fontSize: "10px",
        letterSpacing: "0.5px",
        minWidth: "unset",
        padding: "unset",
        whitespace: "nowrap"
        // whiteSpace: "normal"
    },
    groupHeader: {
        flex: "1 1 320px"
    }
}));
class MaterialListItemTextUnstyled extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleClick = (e) => {
            const { onClick } = this.props;
            onClick && onClick(e);
        };
    }
    render() {
        const { classes, groupHeader, header, primary, label } = this.props;
        const className = groupHeader ? "__group-header" : header ? "__header" : "";
        // ReactTooltip && ReactTooltip.rebuild();
        return (React.createElement(List_1.ListItemText
        // data-tip={primary || null}
        , { "data-tip": label ? label : typeof primary === "string" ? primary : null, "data-multiline": true, "data-tip-disable": groupHeader || header, className: `material-list-item-text${className} ${this.props
                .className || ""}`, classes: {
                root: groupHeader
                    ? classes.groupHeader
                    : header
                        ? classes.header
                        : classes.root
            }, disableTypography: true, onClick: this.handleClick, primary: primary }, this.props.children));
    }
}
exports.MaterialListItemTextUnstyled = MaterialListItemTextUnstyled;
exports.MaterialListItemText = decorate(MaterialListItemTextUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/list/list-item/list-item-text/list-item-text.tsx
// module id = 3230
// module chunks = 0